/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Authority types supported by MSAL.
 */
export enum AuthorityType {
    Default,
    Adfs,
    Dsts,
    Ciam
}
